var toolTipItems = [
    ["excellentTitle", "excellentBody"],
    ["veryGoodTitle", "veryGoodBody"],
    ["goodTitle", "goodBody"],
    ["fairTitle", "fairBody"],
    ["poorTitle", "poorBody"],
];
export default toolTipItems;
